module.exports = __webpack_public_path__ + "img/10.6380148f.png";